import React from "react";
import "./FailedModal.scss";
import close from "../../../assets/close.svg";
import failed from "../../../assets/failed.svg";
import Button from "../../button/Button";
interface FailedModalProps {
  onClose: () => void;
}
const FailedModal: React.FC<FailedModalProps> = ({ onClose }) => {
  return (
    <div className='modal'>
      <div className='modal-content-failed'>
        <div className='failed-header'>
          <div className='failed-header-left'>
            <img alt='' src={failed} className='failed-ic ' />
            <div className='failed-header-text'>Verification Failed</div>
          </div>
          <div className='failed-header-right'>
            <img alt='' src={close} className='close-ic' onClick={onClose} />
          </div>
        </div>
        <div className='failed-content-qr'>
          <div className='failed-content-qr-text'>
            You verification failed, Please retry the process or contact support
          </div>
          <div className='failed-btn-cont'>
            <Button text='Ok' onClick={onClose} isPrimary />
          </div>
        </div>
      </div>
    </div>
  );
};
export default FailedModal;
